import { Link } from "react-router-dom";
import type { Article } from "../../mocks/articles";
import { getCategory } from "../../mocks/site";
import { formatCount } from "../../utils/format";

type Props = {
  article: Article;
  showSummary?: boolean;
};

export function ArticleCard({ article, showSummary = true }: Props) {
  const cat = getCategory(article.category);
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.coverAlt}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {cat && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
            <i className={`${cat.icon} text-primary-600`} aria-hidden="true"></i>
            {cat.name}
          </span>
        )}
        <span className="absolute bottom-3 right-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {formatCount(article.views)} 阅读
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {article.title}
        </h3>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.summary}</p>
        )}
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" aria-hidden="true"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {article.date}
          </span>
        </div>
      </div>
    </Link>
  );
}